module.exports = __webpack_public_path__ + "img/quit_icon.911db639.svg";